import { render, staticRenderFns } from "./PreviewMail.vue?vue&type=template&id=480ebfab&"
import script from "./PreviewMail.vue?vue&type=script&lang=js&"
export * from "./PreviewMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports